import React from "react";
import PropTypes from "prop-types";
import TextInfo from "@/bit/components/components.text";

const CmsVideoText = (props) => {
  const {
    videoSrc,
    videoTitle,
    cmsHandler = null,
    blockName,
    alias,
    index,
    frontalListToDelete,
    CmsEditableGroupIcons,
  } = props;

  return (
    <>
      <div className="video-text-card" data-cy="Video Text Card">
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            noCustomLink
            elementProps={{
              ...props,
              editName: "cms-block.cms-video-text",
            }}
            deleteProps={{
              index,
              itemIdDotNotation: `${blockName}.cms-ml-video-text-list-1`,
              alias,
              frontalListToDelete,
            }}
            visibleTools={{
              hiring: false,
              edit: true,
              deleteItem: true,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        {props["cms-atom-text-1"] && (
          <TextInfo
            {...props["cms-atom-text-1"]}
            kind="h"
            level="3"
            className="video-text-card-title"
            cmsHandler={cmsHandler}
          />
        )}
        {props["cms-atom-text-2"] && (
          <TextInfo
            {...props["cms-atom-text-2"]}
            kind="div"
            className="video-text-card-description"
            cmsHandler={cmsHandler}
          />
        )}
        {(videoSrc || cmsHandler) && (
          <div className={`video-text-card-video`} data-cy="Video Text Video">
            <iframe
              src={videoSrc}
              title={videoTitle || ""}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        )}
      </div>
      <style jsx>{`.video-text-card {
  position: relative;

  :global(.video-text-card-title) {
    margin-bottom: 8px;
  }

  .video-text-card-video {
    position: relative;
    width: 100%;
    max-width: 560px;
    aspect-ratio: 16 / 9;
    margin: 0 auto 16px;
    padding-top: 1rem;

    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
    }

    &.video-text-card-video--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed currentColor;
      cursor: pointer;
    }
  }
}
`}</style>
    </>
  );
};

export default CmsVideoText;

CmsVideoText.propTypes = {
  /**
   * {
   *  "info": "Enlace del video desde youtube",
   *  "kind": "both",
   *  "beautifulName": "Enlace de video"
   * }
   */
  videoSrc: PropTypes.string,
  /**
   * {
   *  "info": "Título del video desde youtube",
   *  "kind": "both",
   *  "beautifulName": "Título de video"
   * }
   */
  videoTitle: PropTypes.string,
};

CmsVideoText.defaultProps = {
  videoSrc: "",
  videoTitle: "",
};
